import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const FactoryRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.factory_master_create === true ||
    permissions.factory_master_edit === true ||
    permissions.factory_master_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default FactoryRouteMiddleware;
